import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import Button from 'views/Button.js';

// The recurring "Find Your Solution" call-to-action. Rendered as a dark, elevated
// card so it reads as a true action module — deliberately high-contrast against
// the white/off-white content rhythm instead of fading into it.
const QuizCTA = ({ onOpenQuiz, heading, subtext, buttonLabel, buttonIcon }) => {
    return (
        <section style={{
            borderBottom: `1px solid rgba(65,65,65,1)`,
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                margin: '0 auto',
                background: 'linear-gradient(160deg, #24242a 0%, #141417 100%)',
                boxShadow: '0 26px 60px rgba(15, 23, 42, 0.30)',
                minHeight: Utils.isMobile() ? null : 625,
                padding: Utils.isMobile() ? '44px 26px' : '62px 56px',
                textAlign: 'center',
                width: '100%'
            }}>
                {/* Accent glow — sized to the taller card, anchored in the top-right corner */}
                <div style={{
                    position: 'absolute',
                    top: Utils.isMobile() ? -120 : -220,
                    right: Utils.isMobile() ? -80 : -180,
                    width: Utils.isMobile() ? 320 : 640,
                    height: Utils.isMobile() ? 320 : 640,
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${Utils.hexToRGBA(Appearance.colors.primary(), 0.45)} 0%, rgba(0,0,0,0) 70%)`,
                    pointerEvents: 'none',
                }} />

                <div style={{ position: 'relative' }}>
                    <img 
                    src={'/images/splash-icon.png'}
                    style={{
                        width: 75,
                        height: 75,
                        borderRadius: 37.5,
                        backgroundColor: Appearance.colors.primary(),
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 16,
                        boxShadow: `0 10px 24px ${Utils.hexToRGBA(Appearance.colors.primary(), 0.45)}`,
                    }} />

                    <h3 style={{
                        ...Appearance.textStyles.sectionHeading({ textAlign: 'center' }),
                        color: Appearance.colors.white,
                        marginBottom: 14,
                        textWrap: 'balance',
                    }}>
                        {heading || 'Not sure how many sensors your home needs?'}
                    </h3>
                    <p style={{
                        ...Appearance.textStyles.body({ fontSize: 16 }),
                        color: 'rgba(255, 255, 255, 0.72)',
                        maxWidth: 520,
                        margin: '0 auto',
                    }}>
                        {subtext || 'Answer two quick questions and we’ll size the right coverage for your home — in under a minute.'}
                    </p>

                    <div style={{ marginTop: 30 }}>
                        <Button label={buttonLabel || 'Find Your Solution'} type={'primary'} icon={buttonIcon || 'fas fa-magic'} onClick={onOpenQuiz} style={{ padding: '16px 40px', fontSize: 16 }} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuizCTA;
